<style scoped>
  .process-button{
    width: 160px;
  }
  .secured1{
    margin-top: 5px;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
  .ivu-alert {
    padding: 8px 16px 8px 16px !important;
  }
  .space-between {
    justify-content: space-between;
  }
  .flex-end {
    justify-content: flex-end;
  }
  .item01 { order:0; }
  .item02 { order:1; }

  .cards {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin-top: 0px;
    margin-bottom: 10px;
  }
  .card-image {
    height: 30px; width: 30px;
  }
</style>


<template>

    <ModalHolder m-top="55" :title="''" :is-show="showDonate" :mWidth="'90%'"
      :mHeight="'55vh'" :closable="true"
      @on-close="donateHide()">
      <template slot="mheader">
        <!-- <div class="donate-header"> -->
          <div class="group-header">
            <div class="cover-photo" v-if="careplan.thumbnail_photo" :style="{ 'background-image': 'url(' + careplan.thumbnail_photo[0].medium + ')' }">
            </div>
            <h3 style="margin-top:23px">{{careplan.title}}</h3>
          </div>
        <!-- </div> -->
      </template>
      <template slot="mcontent">
        test
        <Row>
          <Steps :current="currentStep" size="small">
            <Step title="Donate">
            </Step>
            <Step title="Amount" content=""></Step>
            <Step title="Payment" content=""></Step>
          </Steps>
        </Row>
        <br>

        <!-- start: STEP - 1 -->
        <Row v-show="currentStep==0">
          <Alert>
            <p><b>Donate Today</b></p>
            <div class="flex-container space-between">
              <p>What type of donation do you want to make?</p>
            </div>
            <!-- <div class="flex-container flex-end">
              <p style="font-size:10px;">
                Secure <Icon type="ios-locked"></Icon>
              </p>
            </div>               -->
          </Alert>
          <br>
          <div style="text-align:center;">
            <ButtonGroup vertical>
              <Row>
                <b>Option 1:&nbsp;</b>
                <Button type="primary" class="process-button" :class="{ active: activeAmount === 1 }" v-on:click="activeAmount = 1">
                  Online Donation
                </Button>
              </Row>
              <br>
              <Row>
                <b>Option 1:&nbsp;</b>
                <Button type="primary" class="process-button" :class="{ active: activeAmount === 2 }" v-on:click="activeAmount = 2">
                  Direct Deposit
                </Button>
              </Row>
            </ButtonGroup>
          </div>
        </Row>
        <!-- end: STEP - 1 -->

        <!-- start: STEP - 2 -->
        <Row v-show="currentStep==1">
          <div class="select-amount">
            <h3>Select an amount</h3>
            <div class="amounts">
              <Row :gutter="16">
                <div class="amount" v-for="(amount, indx) in amounts" :key="indx">
                  <Col span="8">
                    <Button type="primary" :class="{ active: activeAmount === indx }" v-if="indx < 6"
                      v-on:click="activeAmount = indx" style="width: 100%;margin-top: 10px;" size="large">₱ {{amount.toLocaleString()}}</Button>
                  </Col>
                </div>
              </Row>
            </div>
          </div>
          <div class="other-amount" style="margin-top: 10px;">
            <Row :gutter="16">
              <Col span="8">
                <Button type="primary" style="width:100%;" size="large"
                  :class="{ active: activeAmount === 6 }" v-on:click="activeAmount = 6;">₱ 50,000</Button>
              </Col>
              <Col span="16">
                <Input @on-focus="onInputPrice()" v-model="items.price" step="any" @on-change="validatePrice" placeholder="Other amount" min="500" size="large"></Input>
              </Col>
            </Row>
          </div>

        </Row>
        <!-- end: STEP - 2 -->

        <!-- start: STEP - 3 -->
        <Row v-show="currentStep==2">
          <div class="cards">
            <img alt=" " src="@/assets/visa.png" class="card-image">
            <img alt=" " src="@/assets/master-card.png" class="card-image">
            <!-- <img src="@/assets/paypal.png" class="card-image"> -->
            <img alt=" " src="@/assets/american-express.png" class="card-image">
            <img alt=" " src="@/assets/discover.png" class="card-image">
          </div>
        </Row>
        <!-- end: STEP - 3 -->

      </template>
      <template slot="mfooter">
        <Button type="primary" :disabled="currentStep==0" @click="stepPrevious()">Previous</Button>
        <Button type="primary" v-show="currentStep<2" :disabled="currentStep==2" @click="stepNext()">Next</Button>
        <Button type="primary" v-show="currentStep==2">Pay</Button>
      </template>
    </ModalHolder>
</template>


<script>
import _ from 'lodash'
import ModalHolder from "@/components/ModalHolderComponent";

export default {
  name: 'DonateStepsComponent',
  components: {
    ModalHolder
  },
  props: {
    showDonate: Boolean, required: true, default: false
  },
  data() {
    return {
      currentStep: 0,
      amounts: ['500', '1,000', '2,500', '5,000', '10,000', '25,000'],
      amount: null,
      activeAmount: null,
      cardInfo: {
        type: 'mastercard',
        number: null,
        expire_month: null,
        expire_year: null,
        pin: null,
        first_name: null,
        last_name: null
      },
      items: {
        name: null,
        sku: null,
        description: null,
        quantity: 1,
        price: null,
      },
    }
  },
  computed: {
    careplan: function() {
      return this.$store.state.resource.singleResource.data
    }
  },
  methods: {
    donateHide: function() {
      this.$store.commit('donation/setShowDonate', false);
      this.currentStep=0;
    },
    stepNext: function() {
      this.currentStep++;
    },
    stepPrevious: function() {
      this.currentStep--;
    },
    onInputPrice: function() {
      this.activeAmount = null
    },
    validatePrice() {
      if (this.items.price) {
          this.showPaymentInfo = this.items.price < 500
      }
    }
  }
}

</script>
